<template>
  <div class="index">
    <div class="pre">
      <div>
        <div class="pre_left">
          <span class="prel_sp1">分类</span>
          <el-menu
            :default-active="typeIndex"
            @select="handleSelect"
          >
            <el-menu-item index="0">
              <i class="el-icon-view"></i>
              <span slot="title">植物药</span>
            </el-menu-item>
            <el-menu-item index="1">
              <i class="el-icon-view"></i>
              <span slot="title">化学药</span>
            </el-menu-item>
          </el-menu>
        </div>
      </div>

      <div class="pre_right" v-show="typeIndex == '0'">
        <div class="prer_bot">
          <div class="prerbot_d1">
            <ul v-for="(item, index) in botanicalList" :key="index">
              <li>
                <span @click="toDetail(item.id)">{{ item.name }}</span>
              </li>
            </ul>
          </div>
          <div class="prerbot_d2">
            <el-pagination
              class="prerbot_d2_elp"
              background
              @current-change="handleCurrentChange"
              :page-size="30"
              :layout="
                device === 'mobile'
                  ? 'prev, pager'
                  : 'total, prev, pager, next, jumper'
              "
              :total="allCount"
            >
            </el-pagination>
          </div>
        </div>
      </div>

      <div class="pre_right" v-show="typeIndex == '1'">
        <div class="prer_bot">
          <div class="prerbot_d1">
            <ul v-for="(item, index) in chemistryList" :key="index">
              <li>
                <span @click="toDetail2(item.id)">{{ item.name }}</span>
              </li>
            </ul>
          </div>
          <div class="prerbot_d2">
            <el-pagination
              class="prerbot_d2_elp"
              background
              @current-change="handleCurrentChange2"
              :page-size="30"
              :layout="
                device === 'mobile'
                  ? 'prev, pager'
                  : 'total, prev, pager, next, jumper'
              "
              :total="allCount2"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="indexd3">
      <img src="../Home/img/图层49.png" />
    </div>
    <div class="index_d2">
      <div class="indexd2_top">
        <p>产品推荐</p>
      </div>
      <div class="indexd2_down">
        <div
          class="prolist"
          v-for="(item, index) in proList"
          :key="index"
          @click="toNCPDetail(item.id)"
        >
          <img class="pro_img" :src="imgUrl+item.Pic" />
          <div class="pro_text">{{ item.Intro}}</div>
          <div class="pro_pic">
            ￥<span>{{ item.Price }}</span>
          </div>
          <a>
            <img @click.stop="AddCart(item.id)" class="pro_gwcimg" src="../Home/img/gouWuChe.png" />
          </a>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VUE_APP_IMG_URL } from "@/config";
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      list: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "X",
        "Y",
        "Z",
      ],
      pretselect: -1,
      allCount: "",
      allCount2: "",
      page: 0,
      page2: 0,
      typeIndex: "0",
      imgUrl: "",
      rxlist: [],
      prescriptionList: [],
      data: [],
      chemistryList: [],
      botanicalList: [],
      typeId: "",
      ProductSizeId:'',
			num:1,
			id:'',
	    proList:[],
    };
  },
  computed: {
    ...mapGetters(["seachKey","device"]),
  },
  watch: {
    seachKey(newval, olval) {
			this.page = 0
			this.GetNcpProductList()
        },
  },
  created: function () {
    this.imgUrl = VUE_APP_IMG_URL;
  },
  mounted: function () {
    this.$post(this.$store.state.url + "GetChemistryDrugsList", {}).then(
      function (res) {}
    );
    this.$post(this.$store.state.url + "GetBotanicalDrugsList", {}).then(
      function (res) {}
    );

    this.GetChemistryDrugsList();
    this.GetBotanicalDrugsList();
    this.getRXProductList();
	this.GetNcpProductList();
  },
  methods: {
    ...mapMutations("goods", ["SET_SEACH_KEY"]),
    select(index) {},
    handleSelect(e) {
      this.typeIndex = "" + e;
    },
    GetBotanicalDrugsList() {
      var that = this;
      that
        .$post("GetBotanicalDrugsList", {
          page: that.page,
        })
        .then(function (res) {
          that.botanicalList = res.data.ResultData;
          that.allCount = res.data.RowCount;
        });
    },
    GetChemistryDrugsList() {
      var that = this;
      that
        .$post("GetChemistryDrugsList", {
          page: that.page2,
        })
        .then(function (res) {
          that.chemistryList = res.data.ResultData;
          that.allCount2 = res.data.RowCount;
        });
    },
    async GetNcpProductList() {
      let res = await this.$post("GetNcpProductList", {
        pageSize: 4,
      });
      console.log(res, "proList");
      this.proList = res.data.ResultData;
      this.proList.forEach((pro) => {
        pro.Intro = this.truncate(pro.Intro, 15);
        console.log(pro.Intro);
      });
    },
    truncate(value, length) {
     if (!value || value.length <= length) {
       return value;
     }
     return value.slice(0, length) + "...";
    },
    handleCurrentChange(e) {
      this.page = e - 1;
      window.scrollTo(0, 0);
      this.GetBotanicalDrugsList();
    },
    handleCurrentChange2(e) {
      this.page2 = e - 1;
      window.scrollTo(0, 0);
      this.GetChemistryDrugsList();
    },
    getRXProductList() {
      var that = this;
      that
        .$post("GetRXProductList", {
          page: 0,
        })
        .then(function (res) {
          that.rxlist = res.data.ResultData;
          for (var i in that.rxlist) {
            that.rxlist[i].Pic = that.rxlist[i].Pic.split(",")[0];
          }
        });
    },
    async AddCart(id) {
				this.id=id
    		  if (this.userId == "") {
    		    this.$router.push("/login");
    		    this.$message.error("请先登录后查看");
    		    return;
    		  }
			  let res = await this.$post("productDeatil", {id: this.id});
			  console.log(res,'productDeatil');
    		  this.ProductSizeId=res.data.ResultData.SizeList[0].id;
    		  if(this.ProductSizeId==''){
    		    this.$message.error("商品维护中，暂不可加入购物车");
    		  }else{
    		    let res = await this.$post("AddCart", {
    		      ProductId: this.id,
    		      Count: this.num,
    		      ProductSizeId:this.ProductSizeId
    		    });
    		    console.log(res,'addcart');
    		    this.$store.commit('updatecarSize', res.data.RowCount)
    		    if (res.data.Success == "true") {
    		      this.$message({
    		        message: res.data.Msg,
    		        type: "success",
    		      });
    		    } else {
    		      this.$message.error(res.data.Msg);
    		    }
    		  }
    		},	
    toDetail(id) {
      this.$router.push({
        path: "/chemicalsDetail",
        query: {
          type: 1,
          id: id,
        },
      });
    },
    toNCPDetail(id) {
				this.$router.push({
					path: '/ncpgoodsdetail',
					query: {
						id: id
					}
				});
		},
    toDetail2(id) {
      this.$router.push({
        path: "/chemicalsDetail",
        query: {
          type: 2,
          id: id,
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


<style scoped>
.index {
  width: 100%;
  background-image: url("../Home/img/组17.png");
  background-size: cover;
  /* 调整背景图片的尺寸，以填充整个容器 */
  background-position: center;
}
.indexd3 {
  width: 100%;
  margin-top: 50px;
}
.indexd3 img {
  width: 100%;
}
.index_d2 {
  width: 100%;
}
.indexd2_top{
  margin: 0 auto;
  width: 465px;
  height: 100px;
  margin-top: 50px;
  background-image: url("../Home/img/图层44.png");
  background-size: 100% 100%;
  text-align: center;
  line-height: 100px;
  letter-spacing: 20px;
  font-size: 36px;
  font-family: "SimSun", "STSong", serif;
  font-weight: bold;
  color: white;
}
.indexd2_top p{
  margin-left: 40px;
}
.indexd2_down{
  width: 60%;
  margin: 0 auto;
  margin-top: 50px;
  display: flex;
}
.prolist{
  border: 2px solid #ccc;
  margin: 15px;
  background-color: white;
  padding: 10px 20px;
}
.pro_img{
  width: 200px;
}
.pro_text{
  font-size:0.8em;
  
}
.pro_pic{
  color: red;
  margin-top: 15px;
  float: left;
}
.pro_pic span{
  font-size: 1.5em;
}
.pro_gwcimg{
  height: 25px;
  width: 25px;
  margin-top: 20px;
  float: right;
}
</style>

<style lang="scss" scoped src="./mobile.scss" ></style>